import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../core/header/header.component';
import { FooterComponent } from '../core/footer/footer.component';
import { LearnMoreComponent } from '../core/learn-more/learn-more.component';
import { BackToTopButtonComponent } from './back-to-top-button/back-to-top-button.component';
import { InformationCardComponent } from './information-card/information-card.component';
import { RouterModule } from '@angular/router';
import { TermsAndConditionsContentComponent } from './terms-and-conditions-content/terms-and-conditions-content.component';
import { UserService } from '../core/services/user/user.service';
import { ConnectionPopupComponent } from './connection-popup/connection-popup.component';
import { MaterialModule } from '../material.module';
import { CookieConsentComponent } from './cookie-consent/cookie-consent.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    LearnMoreComponent,
    BackToTopButtonComponent,
    InformationCardComponent,
    TermsAndConditionsContentComponent,
    ConnectionPopupComponent,
    CookieConsentComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    LearnMoreComponent,
    BackToTopButtonComponent,
    InformationCardComponent,
    TermsAndConditionsContentComponent,
    CookieConsentComponent,
  ],
  providers: [
    UserService,
  ],
})
export class SharedModule { }
